import styled from "styled-components";

export const TouchOverlay = styled.div`
  padding: 0;
  margin: 0;
  cursor: pointer !important;
  display: inline-block;
`;
